import React from 'react';
import styled from 'styled-components';

import { useHideDiscountFromConsumer } from 'shared/hooks/use-hide-discounts-from-consumer';
import useAppliedOffers from 'src/hooks/use-applied-offers';
import useCart from 'src/hooks/use-cart';
import { useHideSalesLanguage } from 'src/hooks/use-hide-sales-language';

import SvgGenericCheckmark from 'src/assets/generic-checkmark';

export const AppliedOffers = (): JSX.Element | null => {
  const { dispensary } = useCart();
  const hideDiscounts = useHideDiscountFromConsumer(dispensary);
  const hideSalesLanguage = useHideSalesLanguage(dispensary?.location?.state);
  const { discountToCartApplied, appliedOffers } = useAppliedOffers();

  if (hideDiscounts || !discountToCartApplied || appliedOffers.length === 0 || hideSalesLanguage) {
    return null;
  }

  return (
    <Wrapper>
      {appliedOffers.map((offer) => (
        <Offer key={offer._id} data-testid='applied-offer'>
          <Name>{offer.name}</Name>
          <Applied>
            <SvgGenericCheckmark color='currentColor' width='12' />
            Applied
          </Applied>
        </Offer>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: #fff;
  border-top: 2px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
`;

const Offer = styled.div`
  align-items: center;
  background: #d1efde;
  border-radius: ${({ theme }) => theme.customized.radius.sm};
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding: 8px;
`;

const Name = styled.div`
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
`;

const Applied = styled.div`
  align-items: center;
  color: #00624a;
  display: flex;
  font-size: 12px;
  gap: 6px;
  line-height: 1;
`;
